import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { IRtpFundingDetails } from '../../interfaces/lmt/rtp-funding-details.interface';
import { AbstractFundingDetailsService } from '../abstraction/abstract.funding-details.service';

@Injectable({
  providedIn: 'root',
})
export class MockFundingDetailsService extends AbstractFundingDetailsService {
  private getFundingDetailsJson =
    'assets/mocks/rtp/accountactivity/lmtActivity/getFundingDetails.json';
  constructor(private http: HttpClient) {
    super();
  }
  override getRtpFundingDetails(): Promise<IRtpFundingDetails | undefined> {
    return lastValueFrom(this.http.get<IRtpFundingDetails>(this.getFundingDetailsJson));
  }
}
